import BrowserChrome from './BrowserChrome';

export default function ChefBefore() {
  return (
    <BrowserChrome url="chefzeitoun.com">
      <div className="chef-before">
        <div className="logo">
          <h3>Chef Zeitoun</h3>
          <small>F I N E &nbsp; C U I S I N E</small>
        </div>
        <div className="mq">
          ◆ RESERVE ONLINE TODAY — CALL 555-0194 ◆ PRIVATE DINING AVAILABLE ◆
        </div>
        <div className="grid">
          <div className="menu">
            <h4>Our Menu</h4>
            {['Appetizers', 'Soups', 'Salads', 'Entrees', 'Seafood', 'Desserts', 'Beverages'].map(
              (l) => (
                <div key={l}>— {l}</div>
              ),
            )}
          </div>
          <div className="photo">[Photo Gallery]</div>
        </div>
        <div style={{ textAlign: 'center', fontSize: 9, marginTop: 6, color: '#c9a961' }}>
          Hours: M–Sat 5pm–10pm • Click <u>here</u> for directions
        </div>
      </div>
    </BrowserChrome>
  );
}
